export default defineNuxtRouteMiddleware(async to => {
  // If this is an async request for one of the assets in the _nuxt dir, skip
  if (to.path.startsWith('/_nuxt/')) {
    return;
  }

  /**
   * Checks status, but also makes sure there's no error in the session,
   * which would indicate that the token wasn't able to be refreshed.
   */
  const isAuthenticated = useIsAuthenticated().value;

  if (to.meta.isLoginPage && isAuthenticated) {
    // If we're trying to reach login page while authenticated, go to the next
    const next = to.query.next as string | undefined || 'profile';
    return navigateTo(next);
  }
  else if (!isAuthenticated && !to.meta.isLoginPage && to.meta.auth !== false) {
    // If we're not authenticated and trying to reach another page (that requires auth), go to login
    return navigateTo(`/login?next=${to.fullPath}`);
  }
});
